import { render } from "./issue-strategy.vue?vue&type=template&id=d0de0c5c&scoped=true&ts=true"
import script from "./issue-strategy.vue?vue&type=script&lang=ts"
export * from "./issue-strategy.vue?vue&type=script&lang=ts"

import "./issue-strategy.vue?vue&type=style&index=0&id=d0de0c5c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0de0c5c"]])

export default __exports__